"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GlobalCSS", {
  enumerable: true,
  get: function get() {
    return _GlobalCSS.GlobalCSS;
  }
});

var _GlobalCSS = require("./GlobalCSS");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvR2xvYmFsQ1NTL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEdsb2JhbENTUyB9IGZyb20gJy4vR2xvYmFsQ1NTJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==